// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__VmnXyGOdR7{width:620px}`, "",{"version":3,"sources":["webpack://./src/app/components/appModals/components/confirmModal/confirmModal.module.scss"],"names":[],"mappings":"AAEA,kBACE,WAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.root {\n  width: 620px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__VmnXyGOdR7`
};
export default ___CSS_LOADER_EXPORT___;
